import { Controller } from "@hotwired/stimulus"

// Fills the site map legend's per-status and per-pricing-tier unit counts from
// the "site-map:unit-status-counts" event the SiteMapViewer dispatches, so the
// counts always come from the same status resolution the map itself renders.
export default class extends Controller {
  static targets = ["statusCount", "tierCount"]

  connect() {
    this.handleCounts = (event) => this.apply(event.detail || {})
    window.addEventListener("site-map:unit-status-counts", this.handleCounts)
  }

  disconnect() {
    window.removeEventListener("site-map:unit-status-counts", this.handleCounts)
  }

  apply({ statusCounts = {}, tierCounts = {} }) {
    this.statusCountTargets.forEach((el) => {
      el.textContent = statusCounts[el.dataset.statusKey] || 0
    })
    this.tierCountTargets.forEach((el) => {
      el.textContent = tierCounts[el.dataset.tierKey] || 0
    })
  }
}
